<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center>
        <v-flex xs12 md12>
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <v-flex xs12 md8 class="homeFeedContainer mt-5">
                <!-- <v-layout class="px-5 pb-8" justify-center align-center>
                  <v-text-field
                    class="mr-3"
                    :disabled="loadingSearch"
                    v-model="searchTextModel"
                    :label="$t('labels.searchAcademy')"
                    v-on:keyup.enter="searchText"
                    hide-details
                    outlined
                    rounded
                  >
                    <template v-slot:append>
                      <v-btn
                        text
                        :loading="loadingSearch"
                        :disabled="searchTextModel.length < 3"
                        color="defaultColor"
                        @click="searchText"
                        class="text-capitalize"
                        style="margin-top: -7px"
                      >
                        {{ $t('buttons.search') }}
                      </v-btn>
                    </template>
                  </v-text-field>

                  <academy-filter-button
                    :showIsAssigned="true"
                    :showSort="false"
                    :showDate="false"
                    :showCategory="false"
                    :showClearAll="false"
                    @filterData="(n) => filterData(n)"
                  />
                </v-layout> 

                <v-divider class="mb-4" /> -->

                <v-layout row wrap class="px-10 justify-center">
                  <v-flex
                    xs12
                    sm12
                    md6
                    lg6
                    xl6
                    v-for="(item, index) in data"
                    :key="index"
                  >
                    <v-card
                      class="mx-auto modern-card"
                      elevation="3"
                      @click="handleItemClick(item)"
                    >
                      <v-img
                        :src="item.Image"
                        alt="Training"
                        class="modern-card-image"
                      ></v-img>

                      <v-card-text class="align-center justify-center">
                        <p style="text-align: center">
                          {{ $t("trainingStartDue") }}
                        </p>
                        <div class="d-flex align-center justify-center mb-4">
                          <v-chip
                            color="#0051a4"
                            class="white--text font-weight-bold"
                          >
                            {{ dateConvert(item.StartDate) }}
                          </v-chip>

                          <p
                            style="margin-bottom: 0px; padding-bottom: 0px"
                            class="align-center mx-2"
                          >
                            -
                          </p>

                          <v-chip
                            color="#0051a4"
                            class="white--text font-weight-bold"
                          >
                            {{ dateConvert(item.DueDate) }}
                          </v-chip>
                        </div>
                        <p style="text-align: center">
                          {{ $t("trainingStatus") }}
                        </p>
                        <div class="d-flex align-center justify-center">
                          <v-chip
                            v-if="
                              new Date() > new Date(item.DueDate) &&
                              item.Situation == 'Tamamlanmadı'
                            "
                            color="#b1007c"
                            class="white--text mx-auto font-weight-bold"
                            style="
                              white-space: normal;
                              word-wrap: break-word;
                              text-align: center;
                              padding: 4px !important;
                              height: auto;
                            "
                          >
                            {{ $t("expired") }}
                          </v-chip>

                          <v-chip
                            v-else-if="item.Situation == 'Tamamlandı'"
                            color="#009800"
                            class="white--text mx-auto font-weight-bold"
                          >
                            {{ $t("completed") }}
                          </v-chip>

                          <v-chip
                            v-else
                            color="#FF9400"
                            class="white--text font-weight-bold"
                          >
                            {{ $t("notCompleted") }}
                          </v-chip>
                        </div>
                      </v-card-text>
                      <v-card-title class="modern-card-title justify-center">
                        {{ item.TrainingName }}
                      </v-card-title>

                      <v-card-text
                        v-if="item.Description"
                        class="modern-card-description"
                      >
                        <p v-html="getLimitedDescription(item.Description)"></p>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout class="px-4" justify-center align-center>
                  <v-subheader class="defaultColor--text">{{
                    computedTitle
                  }}</v-subheader>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import AcademyFilterButton from "../../components/Academy/AcademyFilterButton.vue";
import PostService from "../../services/PostService";
export default {
  data: function () {
    {
      return {
        data: [],
        member: "",
        loadingSearch: false,
        isAssigned: 0,
        searchTextModel: "",
        categoryId: "",
        page: 0,
        pageSize: 99999,
        totalCount: "0",
      };
    }
  },
  components: {
    LoadingProgress,
    AcademyFilterButton,
  },
  mounted() {
    this.member = this.$store.state.username;
    this.categoryId = this.$route.params.id;
    this.isAssigned = this.categoryId == 1 ? 1 : 0;
    console.log("Category ID > ", this.categoryId);
    this.getPosts();
  },
  computed: {
    computedTitle() {
      return this.$t("title.totalCount", { count: this.totalCount });
    },
  },
  methods: {
    dateConvert(date) {
      if (!date) return "";

      try {
        let day = date.split(" ")[0].split(".")[0];
        let month = date.split(" ")[0].split(".")[1];
        let year = date.split(" ")[0].split(".")[2];
        return `${day}.${month}.${year}`;
      } catch (error) {
        console.log("Error >> ", error);
        return "";
      }
    },
    getLimitedDescription(description) {
      if (!description || description == "") return "";
      let words = description.split(" ");

      return words.slice(0, 10).join(" ") + "...";
    },
    handleItemClick(item) {
      console.log(item);
      this.$router.push({
        name: "training",
        params: {
          Category: item.Category,
          Description: item.Description,
          Duration: item.Duration,
          Image: item.Image,
          RedirectLink: item.RedirectLink,
          TrainingName: item.TrainingName,
          StartDate: item.StartDate,
          DueDate: item.DueDate,
          Situation: item.Situation,
        },
      });
    },

    searchText() {
      this.getPosts();
    },

    getPosts() {
      this.loadingSearch = true;
      setPageLoading(true);

      PostService.getVizgoContent(
        this.member,
        this.isAssigned,
        this.searchTextModel,
        this.categoryId,
        this.page,
        this.pageSize
      )
        .then((res) => {
          const data = res.data || [];
          this.totalCount = data.length;
          this.data = data;
        })
        .catch(async (err) => {
          window.showError(err);
        })
        .then(() => {
          this.loadingSearch = false;
          setPageLoading(false);
        });
    },

    filterData(item) {
      this.isAssigned = item.isAssigned.value;
      this.getPosts();
    },

    loadMore() {
      this.page++;
      this.getPosts();
    },
  },
};
</script>
<style>
.modern-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s ease-in-out;
  height: 100%;
  cursor: pointer;
}

.modern-card:hover {
  transform: scale(1.02);
}

.modern-card-image {
  height: 200px;
  object-fit: cover;
}

.modern-card-title {
  font-size: 18px;
  font-weight: bold;
  padding: 16px;
}

.modern-card-description {
  padding: 12px 16px;
  font-size: 14px;
  color: #666;
}
</style>
